
import './App.css';
import Header from './components/Header/Header';
import Writers from './components/Writers/Writers';

function App() {
  return (
    <div>
      <Header></Header>
      <Writers></Writers>

    </div>
  );
}

export default App;
